import React, { useEffect, useState } from "react";
import { api, rupee } from "../lib/api";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const empty = { category: "Rent", amount: "", date: new Date().toISOString().slice(0, 10), description: "" };

export default function Expenses() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/expenses").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/expenses", { ...form, amount: Number(form.amount) });
      toast.success("Expense recorded");
      setForm(empty); load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/expenses/${id}`); load();
  };

  const total = items.reduce((a, b) => a + b.amount, 0);

  return (
    <div className="p-6 md:p-10 max-w-6xl mx-auto" data-testid="expenses-root">
      <h1 className="font-display font-bold text-3xl mb-6">Expenses</h1>

      <form onSubmit={save} className="card-soft p-4 grid md:grid-cols-5 gap-3 mb-5">
        <select data-testid="exp-category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="h-12 px-3 rounded-md border bg-white" style={{ borderColor: "var(--border-soft)" }}>
          {["Rent", "Utilities", "Stock purchase", "Salary", "Transport", "Marketing", "Other"].map((c) => <option key={c}>{c}</option>)}
        </select>
        <input data-testid="exp-amount" required type="number" placeholder="Amount ₹" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} className="h-12 px-3 rounded-md border bg-white num" style={{ borderColor: "var(--border-soft)" }} />
        <input data-testid="exp-date" type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="h-12 px-3 rounded-md border bg-white" style={{ borderColor: "var(--border-soft)" }} />
        <input data-testid="exp-desc" placeholder="Note (optional)" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="h-12 px-3 rounded-md border bg-white" style={{ borderColor: "var(--border-soft)" }} />
        <button data-testid="exp-save" className="h-12 rounded-md text-white font-semibold tactile-btn inline-flex items-center justify-center gap-2" style={{ background: "var(--primary)" }}>
          <Plus size={16} /> Add
        </button>
      </form>

      <div className="card-soft">
        <div className="p-4 flex items-center justify-between border-b" style={{ borderColor: "var(--border-soft)" }}>
          <div className="font-display font-semibold">All expenses</div>
          <div className="text-sm">Total: <b className="num" style={{ color: "var(--warning)" }}>{rupee(total)}</b></div>
        </div>
        <table className="w-full text-sm zebra">
          <thead><tr className="text-left" style={{ color: "var(--text-muted)" }}><th className="p-3">Date</th><th>Category</th><th>Note</th><th className="text-right">Amount</th><th></th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="text-center py-10" style={{ color: "var(--text-muted)" }}>No expenses yet.</td></tr>}
            {items.map((e) => (
              <tr key={e.id} className="border-t" style={{ borderColor: "var(--border-soft)" }}>
                <td className="p-3">{e.date}</td>
                <td>{e.category}</td>
                <td>{e.description}</td>
                <td className="text-right num font-semibold">{rupee(e.amount)}</td>
                <td className="text-right pr-3"><button data-testid={`exp-del-${e.id}`} onClick={() => del(e.id)} style={{ color: "var(--error)" }}><Trash2 size={16} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
